import * as React from 'react'
// CComponents
import {Button} from '@frontrow/console/src/components/button'
import Input from '@frontrow/console/src/entities/components/base/input'

// Styles
import * as style from '../../school-admin-form/school-admin-form.module.scss'

// Components
import FormField from '@frontrow/console/src/components/common/form-field'

type Props = {
  onCancel: () => void
  onSubmit: (addDistrictId: number, deleteDistrictId: number) => void
}

function SchoolAdminsDistrictForm(props: Props): React.ReactElement {
  const {onCancel, onSubmit} = props
  const [addDistrictId, setAddDistrictId] = React.useState<number>(NaN)
  const [deleteDistrictId, setDeleteDistrictId] = React.useState<number>(NaN)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSubmit(addDistrictId, deleteDistrictId)
  }

  const addDistrictOnChange = (val: string) => {
    setAddDistrictId(parseInt(val, 10))
  }

  const deleteDistrictOnChange = (val: string) => {
    setDeleteDistrictId(parseInt(val, 10))
  }

  return (
    <form onSubmit={handleSubmit} action="">
      <div className={style.schoolAdminFormContainer}>
        <FormField wrapperStyle={style.schoolAdminGenericFieldContainer} label="Add District By Id">
          <Input
            value={isNaN(addDistrictId) ? '' : addDistrictId}
            type="number"
            placeholder={'District will not be added if empty'}
            onChange={addDistrictOnChange}
          />
        </FormField>
        <FormField
          wrapperStyle={style.schoolAdminGenericFieldContainer}
          label="Delete District By Id"
        >
          <Input
            value={isNaN(deleteDistrictId) ? '' : deleteDistrictId}
            type="number"
            placeholder={'District will not be deleted if empty'}
            onChange={deleteDistrictOnChange}
          />
        </FormField>
      </div>
      <div className={style.schoolAdminFormButtonContainer}>
        <Button style="secondary" addClass={style.schoolAdminFormCancel} onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Update School Admin</Button>
      </div>
    </form>
  )
}

export default SchoolAdminsDistrictForm
